import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import styled from "styled-components";
import "swiper/components/pagination/pagination.min.css";
// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/swiper.min.css";
import data from "../data/rushdata.json";


// install Swiper modules
SwiperCore.use([Pagination, Autoplay]);

const HomeWork = () => {
  const [hover, sethover] = useState(2);
  return (
    <Wrapper>
      <Container>
        <Row>
          <Col sm={12} md={12}>
            <div className="home_work_header">
              <h1>How it works</h1>
              <p>
                We cater to suppliers in the field that need parts or customers
                who are in need of a predictable local delivery with a
                rock-solid ETA they can count on. Suppliers and Individuals who
                use Rush save their customers tens of thousands of dollars.
              </p>
            </div>
          </Col>

          <div className="homeWork__bottom">
            <div className="why_rush_for_mobile">
              <Swiper pagination={true} className="mySwiper">
                {data.homeWork.map(({ id, icon, header, content }) => (
                  <SwiperSlide key={id}>
                    <div className="single__rush">
                      <div className="rush__icon">
                        <img src={icon} alt="icon" />
                      </div>
                      <div className="rush__des">
                        <h2>{header}</h2>
                        <p>{content}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            <div className="why_rush_for_desktop">
              {data.homeWork.map(({ id, icon, header, content }) => {
                console.log(id);
                return (
                  <div
                    // className={`single__rush ${hover === id ? "active" : ""}`}
                    className={
                      hover === id ? "single__rush active" : "single__rush"
                    }
                    onMouseOver={() => sethover(id)}
                    key={id}
                  >
                    <div className="rush__icon">
                      <img src={icon} alt="icon" />
                    </div>
                    <div className="rush__des">
                      <h2>{header}</h2>
                      <p>{content}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Row>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .card.active {
    background: #fb5200;
  }
  .home_work_header {
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 48px;
      line-height: 56px;
      color: #6300ff;
      width: 100%;
      height: 61px;
      text-align: center;
    }

    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 27px;
      color: #6d7d93;
      width: 989px;
      height: 81px;
      text-align: center;
      margin-top: 67px;
    }
  }

  .single__rush:hover {
    transform: scale(1.1);
  }

  @media screen and (max-width: 768px) {
    .home_work_header {
      h1 {
        width: 100%;
        height: 61px;
        text-align: center;
        font-family: Gilroy-Heavy;
        font-size: 36px;
        line-height: 42px;
        color: #6300ff;
      }

      p {
        width: 100%;
        height: 95px;
        text-align: center;
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 30px;
        color: #6d7d93;
      }
    }
    .why_rush {
      padding: 0px 12px !important;
    }

    .single__rush {
      width: 440px !important;
      margin: 0 20px;
    }
    .order {
      position: relative;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    .why_rush_for_desktop {
      display: none !important;
    }
    .why_rush_for_mobile {
      display: block !important;
      width: 100%;
    }
    .mySwiper {
      width: 516px;
      padding: 78px 0;
    }
    .rush__des p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      letter-spacing: 1px;
      margin-top: 10px;
      width: 300px;
    }
  }

  @media screen and (max-width: 440px) {
    .home_work_header {
      h1 {
        width: 100%;
        height: 61px;
        text-align: center;
        font-family: Gilroy-Heavy;
        font-size: 36px;
        line-height: 42px;
        color: #6300ff;
        margin-top: 60px;
      }

      p {
        width: 100%;
        height: 95px;
        text-align: center;
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 30px;
        color: #6d7d93;
      }
    }

    .mySwiper {
      width: 400px !important;
      padding: 78px 0;
    }
    .single__rush {
      width: 400px !important;
      border-radius: 15px !important;
      box-shadow: 0px 0px 50px 0px #e7f5ff !important;
      box-sizing: border-box !important;
      padding: 15px !important;
      margin-left: 8px !important;
      text-align: left;
      width: 380px !important;
      height: 329px;
    }

    .rush__des {
      h2 {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 29px;
        color: #2a60e4;
        margin-top: 55px;
      }
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 22px;
        color: #464861;
        -webkit-letter-spacing: 1px;
        -moz-letter-spacing: 1px;
        -ms-letter-spacing: 1px;
        -webkit-letter-spacing: 1px;
        -moz-letter-spacing: 1px;
        -ms-letter-spacing: 1px;
        letter-spacing: 1px;
        margin-top: 10px;
        width: 340px;
      }
    }

    .rush__icon {
      margin-top: 40px;
    }

    .swiper-container-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      max-width: 100% !important;
      display: flex;
      justify-content: center;
    }
    .homeWork__bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      margin-top: 110px;
      margin-bottom: 220px;
      width: 100%;
    }
  }

  @media screen and (max-width: 414px) {
    .home_work_header {
      h1 {
        width: 100%;
        height: 61px;
        text-align: center;
        font-family: Gilroy-Heavy;
        font-size: 36px;
        line-height: 42px;
        color: #6300ff;
        margin-top: 60px;
      }

      p {
        width: 100%;
        height: 95px;
        text-align: center;
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 30px;
        color: #6d7d93;
      }
    }

    .mySwiper {
      width: 387px !important;
      padding: 78px 0;
    }
    .single__rush {
      width: 387px !important;
      border-radius: 15px !important;
      box-shadow: 0px 0px 50px 0px #e7f5ff !important;
      box-sizing: border-box !important;
      padding: 15px !important;
      margin-left: 8px !important;
      text-align: left;
      width: 366px !important;
      height: 329px;
    }

    .rush__des {
      h2 {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 29px;
        color: #2a60e4;
        margin-top: 55px;
      }
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 22px;
        color: #464861;
        -webkit-letter-spacing: 1px;
        -moz-letter-spacing: 1px;
        -ms-letter-spacing: 1px;
        -webkit-letter-spacing: 1px;
        -moz-letter-spacing: 1px;
        -ms-letter-spacing: 1px;
        letter-spacing: 1px;
        margin-top: 10px;
        width: 340px;
      }
    }

    .rush__icon {
      margin-top: 40px;
    }

    .swiper-container-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      max-width: 387px !important;
      display: flex;
      justify-content: center;
    }
    .homeWork__bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      margin-top: 110px;
      margin-bottom: 220px;
      width: 100%;
    }
  }

  .why_rush_for_mobile {
    display: none;
  }
  .why_rush_for_desktop {
    display: flex;
    flex-direction: row;
    align-items: space-between;
    width: 100%;
    margin: auto;
  }

  .homeWork__bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    margin-top: 110px;
    margin-bottom: 180px;
  }

  .rush__icon {
    padding-left: 5px;
  }

  .rush__des {
    margin-top: 52.87px;
    h2 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 24px;
      line-height: 29px;
      color: #2a60e4;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      letter-spacing: 1px;
      margin-top: 12px;
    }
  }

  .single__rush {
    width: 340px;
    border-radius: 15px !important;
    /* box-shadow: 0px 0px 50px 0px #e7f5ff !important; */
    box-sizing: border-box !important;
    padding: 15px !important;
    margin-right: 50px;
    text-align: left;
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    cursor: pointer;
    transition: 0.3s;
  }
  .single__rush.active {
    width: 340px;
    border-radius: 15px !important;
    box-shadow: 0px 0px 50px 0px #e7f5ff !important;
    box-sizing: border-box !important;
    padding: 15px !important;
    margin-right: 50px;
    text-align: left;
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    cursor: pointer;
    transition: 0.3s;
  }
  .swiper-container.swiper-container-initialized.swiper-container-horizontal.swiper-container-pointer-events.mySwiper {
    padding-bottom: 90px;
  }
  .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    width: 500px !important;
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 4px;
    width: 10px;
    height: 5px;
    border-radius: 5px;
  }
`;

export default HomeWork;
